import { useState, useEffect } from "react";
import { GetUser } from "../../Services";
import Modal from "../../components/Modal";
import AddEditPassenger from "../../forms/passengers/AddEditPassenger";

const Passenger = () => {
  const [passengers, setPassengers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editingPassenger, setEditingPassenger] = useState(null);

  useEffect(() => {
    const fetchPassengers = async () => {
      setLoading(true);
      try {
        const data = await GetUser.fetchPassengerList(currentPage);
        setPassengers(Array.isArray(data.passengers) ? data.passengers : []);
        setTotalPages(data.totalPages || 1);
      } catch (error) {
        console.error("Error fetching passengers:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchPassengers();
  }, [currentPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this passenger?"))
      return;

    try {
      await GetUser.deletePassenger(id);
      setPassengers((prev) => prev.filter((p) => p.id !== id));
    } catch (error) {
      console.error("Error deleting passenger:", error);
    }
  };

  const handleEdit = (passenger) => {
    setEditingPassenger(passenger);
    // setFormData(passenger);
    setShowModal(true);
  };

  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <h2 className="text-2xl font-bold">Manage Passengers</h2>
        </div>

        <Modal showModal={showModal} setShowModal={setShowModal}>
          <AddEditPassenger
            editingPassenger={editingPassenger}
            setEditingPassenger={setEditingPassenger}
            setPassengers={setPassengers}
            setShowModal={setShowModal}
          />
        </Modal>
        <div className="card">
          <div className="card-header flex items-center justify-between">
            {/* <div className="form-group"> */}
            <button
              type="button"
              className="btn btn-primary btn-sm flex items-center"
              onClick={() => setShowModal(true)}
            >
              <i className="fa fa-user mr-1"></i>Add Passenger
            </button>
            {/* </div> */}
          </div>
          <div className="card-body">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Phone</th>
                  <th>Email</th>
                  <th>Total Rides</th>
                  <th>Ratings</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan={7}>Loading passengers...</td>
                  </tr>
                ) : passengers.length ? (
                  passengers.map((p) => (
                    <tr key={p.id}>
                      <td>{p.id}</td>
                      <td>{p.name}</td>
                      <td>{p.phone_number}</td>
                      <td>{p.email}</td>
                      <td>{p.totalRides ?? 0}</td>
                      <td>{p.ratings ?? 0}</td>
                      <td>
                        <button
                          className="btn btn-sm btn-primary mr-1"
                          onClick={() => handleEdit(p)}
                        >
                          <i className="fas fa-edit"></i>
                        </button>
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={() => handleDelete(p.id)}
                        >
                          <i className="fas fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={7}>No passengers found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="card-footer clearfix">
            <ul className="pagination pagination-sm m-0 float-right">
              <li className="page-item">
                <a
                  className="page-link"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    if (currentPage > 1) handlePageChange(currentPage - 1);
                  }}
                >
                  &laquo;
                </a>
              </li>
              {[...Array(totalPages).keys()].map((page) => (
                <li
                  className={`page-item ${
                    currentPage === page + 1 ? "active" : ""
                  }`}
                  key={page + 1}
                >
                  <a
                    className="page-link"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handlePageChange(page + 1);
                    }}
                  >
                    {page + 1}
                  </a>
                </li>
              ))}
              <li className="page-item">
                <a
                  className="page-link"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    if (currentPage < totalPages)
                      handlePageChange(currentPage + 1);
                  }}
                >
                  &raquo;
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Passenger;
